module.exports = __webpack_public_path__ + "static/media/app1.005c1e9e.jpg";